// Get Cookie function
const getCookie = (name) => {
  const matches = document.cookie.match(
    new RegExp(
      '(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)',
    ),
  );

  // usually a cookie value is encoded, so decode it.
  return matches ? decodeURIComponent(matches[1]) : undefined;
};

// Get li_fat_id value
export const setLiFatId = () => {
  if (typeof window.li_fat_id === 'undefined') {
    window.li_fat_id =
      (typeof window !== 'undefined' &&
        new URLSearchParams(window.location.search).get('li_fat_id')) ||
      (typeof document !== 'undefined' && getCookie('li_fat_id')) ||
      '';
  }
};

// Generate uuid function
export const generateUUID = () => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const hashData = async (value) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(value);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  // Convert buffer to hexadecimal string
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray
    .map((b) => {
      return b.toString(16).padStart(2, '0');
    })
    .join('');
  return hashHex;
};

/**
 * Hashed emails help improve tracking, mainly for LinkedIn CAPI.
 * This is intended to be used in the payload of a `track`
 * event. Eventually we should consider sending this
 * as a `trait` during an `identify` call.
 */
export const createRedactedUserProperties = async ({
  email,
}: {
  email?: string | undefined;
}) => {
  const properties: Record<string, string> = {};

  if (email) {
    const hashedEmail = await hashData(email.toLowerCase().trim());
    properties.sha256_email_address = hashedEmail;
  }

  return properties;
};

/**
 * `window.analytics` object is not always guaranteed to
 * be available. This function guards against that.
 *
 * @see `src/contexts/AnalyticsContext/AnalyticsContext.tsx`
 */
export const ensureAnalyticsAvailable = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  if (!window.analytics) {
    // eslint-disable-next-line no-console
    console.error(
      'Failed to initialize because window.analytics global is not available',
    );
    return false;
  }

  return true;
};
